import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ResetPasswordState {
  email: string | null;
}

const initialState: ResetPasswordState = {
  email: null,
};

export const resetPasswordSlice = createSlice({
  name: "resetPassword",
  initialState,
  reducers: {
    setEmail: (state, action: PayloadAction<string | null>) => {
      state.email = action.payload;
    },
  },
});

export const { setEmail } = resetPasswordSlice.actions;

export default resetPasswordSlice.reducer;
